<template>
  <div class="comp-x-popup">
    <el-dialog :visible="isShow" :width="width"  :appendToBody='appendToBody'  :close-on-click-modal="false" :top="top"  @close="fCancalPopupShow">
      <div :style="{ height: height }">
        <div :style="{ 'background-color': headBgc }"
          class="x-h50 x-flex x-row-between c-e  x-font-14 x-p-t-15 x-p-b-15 x-p-l-15 x-bd-bottom-E">
          <div style="color: #808080;">{{ title }}</div>
          <div class="x-flex x-flex-1 x-row-right">
            <slot name="head"></slot>
            <!-- <div style="border-radius: 50%;border: 1px solid #808080;"> -->
<!--            <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;"
              @click="fCancalPopupShow"></i> -->
              <div class="x-flex x-cur-poi x-w40 x-row-right x-p-r-15 x-h50" @click="fCancalPopupShow">
                <i class="el-icon-close x-font-14 x-p-2 " style=" color:#808080 ;"
                  ></i>
              </div>
            <!-- </div> -->

          </div>
        </div>
        <!-- <div
          style="background-color: #fff; height: calc(100% - 50px)"
          class="x-w100p x-p-10"
        > -->
        <div class="x-bd-ra-4 bgc-f "
         :class="table?'':'x-p-10-20'"
         style="overflow-y: auto;height: calc(100% - 50px)">
          <slot></slot>
        </div>
        <!-- </div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      // 是否显示
      isShow: {
        type: [String, Boolean],
        default: false,
      },
      table: {
        type: [String, Boolean],
        default: false,
      },
      width: {
        type: [String],
        default: "500px",
      },
      height: {
        type: [String],
        default: "auto",
      },
      headBgc: {
        type: [String],
        default: "#fff",
      },
      title: {
        type: [String],
        default: "",
      },
      top: {
        type: [String],
        default: "10vh",
      },
      appendToBody:{
        type: [String, Boolean],
        default: false,
      }
    },
    data() {
      return {};
    },
    methods: {
      fCancalPopupShow() {
        this.$emit("close");
      },
    },
  };
</script>

<style lang="less" scoped>
  .comp-x-popup {
    /deep/ .el-dialog {
      overflow: hidden !important;
    }

    /deep/ .el-dialog__body {
      color: #242424 !important;
    }
  }
  //新增嵌套多出来的头部
    /deep/.el-dialog__header{
      display: none;
    }
    //新增嵌套多出来的内边距
    /deep/.el-dialog__body{
      padding: 0px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/x-popup.vue